import { fetchUnauthBoostDetailsById } from '@packages/api';
import { GetStore, getRegionState } from '@packages/stores';

import { captureException, withScope } from '@sentry/react';
import { sentryTags } from '@utils';

import { BoostDetailsStore } from './boost.store';

export const fetchBoostDetailsById = async (get: GetStore<BoostDetailsStore>, boostId: string) => {
  return await withScope(async scope => {
    scope.setTag('boostId', boostId);
    sentryTags({ event: 'fetch.boost', source: 'fetchBoostDetailsById' });
    const { setBoostDetails, setError, setBoostDetailsApiState } = get();
    const region = getRegionState();
    if (!region) {
      return;
    }

    try {
      setBoostDetailsApiState(boostId, 'pending');
      const boostDetails = await fetchUnauthBoostDetailsById({
        boostId,
        region,
      });

      setBoostDetails(boostDetails);
      setBoostDetailsApiState(boostId, 'fulfilled');
      return boostDetails;
    } catch (error) {
      captureException(error as Error);
      setError(error as Error);
      setBoostDetailsApiState(boostId, 'rejected');
    } finally {
      setBoostDetailsApiState(boostId, 'idle');
    }
  });
};
